// Импорты библиотек и компонентов
import React, { useState } from 'react';
import { v4 as uuid } from 'uuid'; // Используем UUID для генерации уникальных идентификаторов
import { Row, Col } from 'react-bootstrap';
import s from './AddTodo.module.css'; // Импорт стилей для компонента
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons'; // Иконка "Плюс"
import Cookies from 'js-cookie'; // Библиотека для работы с cookies

function AddTodo({ todo, setTodo }) {
	const [value, setValue] = useState(''); // Используем хук useState для отслеживания значения ввода задачи

	React.useEffect(() => {
		// Загрузка списка задач из cookies при инициализации компонента
		const savedTodo = Cookies.get('todo');
		if (savedTodo) {
			setTodo(JSON.parse(savedTodo)); // Разбираем JSON и устанавливаем сохраненный список задач
		}
	}, []);

	// Функция для сохранения списка задач в cookies
	const saveTodoToCookies = (newTodo) => {
		Cookies.set('todo', JSON.stringify(newTodo));
	};

	function saveTodo() {
		if (value) {
			const newTask = {
				id: uuid(), // Генерируем уникальный идентификатор для задачи
				title: value,
				status: true
			};
			const newTodo = [...todo, newTask]; // Добавляем новую задачу к существующему списку
			setTodo(newTodo); // Обновляем состояние списка задач
			saveTodoToCookies(newTodo); // Сохраняем измененный список в cookies
		}
		setValue(''); // Очищаем поле ввода после сохранения задачи
	}

	// Возвращаем JSX компонента AddTodo
	return (
		<Row>
			<Col className={s.addTodoForm}>
				<div class="input-group">
					<input
						value={value}
						onChange={(e) => setValue(e.target.value)}
						type="text"
						class={s.inputTask}
						placeholder="Введите задачу"
					/>
					<button
						onClick={saveTodo}
						class={s.buttonTask}
						type="button"
						id="button-addon2"
					>
						<FontAwesomeIcon
							icon={faPlus}
							style={{ color: '#ffffff' }}
						/>
					</button>
				</div>
			</Col>
		</Row>
	);
}

export default AddTodo;
